import React, { useEffect, useState } from 'react'
import { CButton, CCardBody, CCard } from '@coreui/react'
import { CircleCheck, CircleX, CirclePlus, AlignLeft, Info } from 'lucide-react'
import DiagnosisExaminationView from './DiagnosisExaminationView'
import GeneralExaminationView from './GeneralExaminationView'
import { section } from '../../utils/physicalExaminationData'
import DivLoader from '../../components/shared/DivLoader'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { diagnosisQuestions } from '../../utils/physicalExaminationData'
import { CModal, CModalFooter, CModalBody, CModalHeader, CModalTitle, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react'
import HierarchyComponent from './HierarchyComponents'
import CustomAccordionComponent from '../../../src/components/shared/CustomAccordionComponent'
import PESelectedData from './PESelectedData'
import { data } from '../../utils/GESelectedData'
import { GEWithId } from '../../utils/GEWithId'
const PhysicalView = () => {
  const [boxView, setBoxView] = useState('general')
  const [currentView, setCurrentView] = useState('general')
  const [examinationData, setExaminationData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [showAddEditPopup, setShowAddEditPopup] = useState(false)
  const [generalExaminationData, setGeneralExaminationData] = useState(null)
  const [addPopup, setAddPopup] = useState(false)
  const [editModelVisible, setEditModelVisible] = useState(false)
  const [diagnosisExamination, setDiagnosisExamination] = useState(null)
  const [diagnosisExaminationData, setDiagnosisExaminationData] = useState([])
  const [selectedExamination, setSelectedExamination] = useState(null)
  const [show, setShow] = useState(null)
  const [formattedData, setFormattedData] = useState('')

  const getGeneralExaminationData = async () => {
    //    await SaveExtra('Insert', 'PhysicalExaminationDummyData', JSON.stringify(GEWithId));
    try {
      let data = await SaveExtra('Get_By_Type', 'PhysicalExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      setExaminationData(data)
      setGeneralExaminationData(data[0]?.Data)
      setShow(data[0]?.Data)
    } catch (error) {
      console.log('error', error)
      // toast.error('Failed to fetch data', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getDiagnosisExaminationData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'DiagnosisExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setDiagnosisExaminationData(data)
      setDiagnosisExamination(data[0]?.Data)
      setShow(data[0]?.Data)
    } catch (error) {
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getGeneralExaminationData()
  }, [])

  const handleSubmit = async (updatedData) => {
    try {
      setIsPageLoading(true)
      await SaveExtra('Update', 'PhysicalExaminationDummyData', JSON.stringify(updatedData), examinationData[0]?.Id)
      getGeneralExaminationData()
      toast.success('Saved  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleDiagnosisSubmit = async (updatedData) => {
    // await SaveExtra('Insert', 'DiagnosisExaminationDummyData', JSON.stringify(diagnosisExamination), '');
    try {
      setIsPageLoading(true)
      await SaveExtra('Update', 'DiagnosisExaminationDummyData', JSON.stringify(updatedData), diagnosisExaminationData[0]?.Id)
      getDiagnosisExaminationData()
      toast.success('Saved  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleSaveAndClose = (data) => {
    handleSubmit(data)
  }

  const renderView = () => {
    if (currentView === 'diagnosis') {
      return (
        <DiagnosisExaminationView
          diagnosisExamination={diagnosisExamination}
          setDiagnosisExamination={setDiagnosisExamination}
          setShowAddEditPopup={setShowAddEditPopup}
          showAddEditPopup={showAddEditPopup}
          handleSubmit={handleDiagnosisSubmit}
          setAddPopup={setAddPopup}
          handleSaveAndClose={handleSaveAndClose}
          editModelVisible={editModelVisible}
          setEditModelVisible={setEditModelVisible}
          selectedExamination={selectedExamination}
          setSelectedExamination={setSelectedExamination}
        />
      )
    }

    if (currentView === 'general') {
      return (
        <GeneralExaminationView
          generalExaminationData={generalExaminationData}
          setGeneralExaminationData={setGeneralExaminationData}
          setShowAddEditPopup={setShowAddEditPopup}
          showAddEditPopup={showAddEditPopup}
          handleSubmit={handleSubmit}
          setAddPopup={setAddPopup}
          handleSaveAndClose={handleSaveAndClose}
          editModelVisible={editModelVisible}
          setEditModelVisible={setEditModelVisible}
          selectedExamination={selectedExamination}
          setSelectedExamination={setSelectedExamination}
        />
      )
    }
  }

  const [showAllHierarchy, setShowAllHierarchy] = useState(false)
  const [showSelectedData, setShowSelectedData] = useState(false)
  const [showInfoModal, setShowInfoModal] = useState(false)

  return (
    <div className="position-relative patient-theme-page physical-view-theme">
      <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme" style={{ minHeight: '100vh', overflow: 'auto' }}>
        <DivLoader isLoading={isPageLoading}>
          <CCard className="m-2 master-grid-theme__toolbar">
            <CCardBody className="w-100 master-grid-theme__toolbar-body p-2">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div className="d-flex align-items-center gap-2">
                  <CButton
                    onClick={() => {
                      setAddPopup(true)
                      setShowAddEditPopup(true)
                    }}
                    className={`physical-view-theme__toggle-btn ${addPopup ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <CirclePlus size={16} strokeWidth={1.25} />
                    <span className="ms-2">Add</span>
                  </CButton>
                  <CButton
                    onClick={() => {
                      setShowAllHierarchy(!showAllHierarchy)
                    }}
                    className={`physical-view-theme__toggle-btn ${showAllHierarchy ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <span>Show</span>
                  </CButton>

                  {/* <CButton
                    onClick={() => {
                      setShowSelectedData(!showSelectedData)
                    }}
                    className={`physical-view-theme__toggle-btn ${showSelectedData ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <span>ShowData</span>
                  </CButton> */}
                  <CButton
                    onClick={() => {
                      setShowInfoModal(true)
                    }}
                    className="physical-view-theme__toggle-btn physical-view-theme__icon-btn"
                    title="Information"
                    aria-label="Information"
                  >
                    <Info size={16} strokeWidth={1.75} />
                    <span className="ms-2">Info</span>
                  </CButton>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-2">
                  <CButton
                    color="primary"
                    variant={boxView === 'general' ? undefined : 'outline'}
                    onClick={() => {
                      setBoxView('general')
                      setCurrentView('general')
                      getGeneralExaminationData()
                    }}
                  >
                    {/* <AlignLeft size={16} strokeWidth={1.25} /> */}
                    <span className="ms-2">General Physical Examination</span>
                  </CButton>

                  <CButton
                    color="primary"
                    variant={boxView === 'diagnosis' ? undefined : 'outline'}
                    onClick={() => {
                      setBoxView('diagnosis')
                      setCurrentView('diagnosis')
                      getDiagnosisExaminationData()
                    }}
                  >
                    {/* <AlignLeft size={16} strokeWidth={1.25} /> */}
                    <span className="ms-2">Diagnosis Examination</span>
                  </CButton>
                </div>
              </div>
            </CCardBody>
          </CCard>

          {renderView()}

          <CModal alignment="center" size="xl" scrollable visible={showAllHierarchy} onClose={() => setShowAllHierarchy(false)} aria-labelledby="VerticallyCenteredExample" className="patient-theme-modal physical-view-theme__modal">
            <CModalHeader onClose={() => setShowAllHierarchy(false)}>
              <CModalTitle id="VerticallyCenteredExample">{boxView == 'general' ? 'General Examination' : 'Diagnosis Examination'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div className="p-3">
                <CAccordion alwaysOpen className="mt-3">
                  {show &&
                    show.map((item, idx) => (
                      <CAccordionItem key={idx} itemKey={idx} className="mt-2 border" style={{ borderRadius: '10px', marginBottom: '10px', overflow: 'hidden' }}>
                        <CAccordionHeader style={{ borderRadius: '10px 10px 0 0' }}>{item.name}</CAccordionHeader>
                        <CAccordionBody style={{ borderRadius: '0 0 10px 10px', padding: '15px' }}>
                          <HierarchyComponent viewData={item} />
                        </CAccordionBody>
                      </CAccordionItem>
                    ))}
                </CAccordion>
              </div>
            </CModalBody>

            <CModalFooter>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setShowAllHierarchy(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal>

          <CModal size="xl" scrollable visible={showSelectedData} onClose={() => setShowSelectedData(false)} aria-labelledby="VerticallyCenteredExample" className="patient-theme-modal physical-view-theme__modal">
            <CModalHeader onClose={() => setShowSelectedData(false)}>
              <CModalTitle id="VerticallyCenteredExample">{boxView == 'general' ? 'General Examination' : 'Diagnosis Examination'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div className="p-3">
                <PESelectedData physicalExaminationData={data} onFormattedDataRead={setFormattedData} />
              </div>
            </CModalBody>

            <CModalFooter>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setShowSelectedData(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal>

          <CModal alignment="center" size="lg" scrollable visible={showInfoModal} onClose={() => setShowInfoModal(false)} aria-labelledby="PhysicalViewInfoModal" className="patient-theme-modal physical-view-theme__modal physical-view-theme__info-modal">
            <CModalHeader onClose={() => setShowInfoModal(false)}>
              <CModalTitle id="PhysicalViewInfoModal">Information</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div className="physical-view-theme__info-content">
                <h2>Title</h2>
                <ul>
                  <li>
                    Use for the <strong>overall name of the section</strong>.
                  </li>
                  <li>
                    Example: <strong>Neurological Examination</strong>
                  </li>
                </ul>

                <h2>Header</h2>
                <ul>
                  <li>
                    Use when you are starting a <strong>new major category</strong> within the section.
                  </li>
                  <li>Use separate Headers when the content represents distinct areas that should be visually grouped.</li>
                  <li>
                    Example: <strong>Motor Function</strong>, <strong>Reflexes</strong>, <strong>Coordination</strong>
                  </li>
                </ul>

                <h2>Subheader</h2>
                <ul>
                  <li>
                    Use when you need to <strong>break a Header into smaller related groups</strong>.
                  </li>
                  <li>Don't create a Subheader if the Header already clearly describes the group.</li>
                  <li>
                    Example:
                    <br />
                    <strong>Motor Function</strong> → <strong>Upper Extremity</strong>, <strong>Lower Extremity</strong>
                  </li>
                </ul>

                <h2>Option</h2>
                <ul>
                  <li>
                    Use for the <strong>actual selectable responses</strong> under a Header or Subheader.
                  </li>
                  <li>
                    Example: <strong>Normal</strong>, <strong>Impaired</strong>, <strong>Absent</strong>
                  </li>
                </ul>

                <h2>Single vs. Multi</h2>
                <ul>
                  <li>
                    <strong>Single:</strong> Use when only <strong>one response</strong> should apply.
                    <ul>
                      <li>
                        Example: <em>Severity → Mild / Moderate / Severe</em>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>Multi:</strong> Use when <strong>multiple responses</strong> can apply at the same time.
                    <ul>
                      <li>
                        Example: <em>Symptoms → Tremor / Rigidity / Bradykinesia</em>
                      </li>
                    </ul>
                  </li>
                </ul>

                <h2>Default Value</h2>
                <ul>
                  <li>
                    Turn on when an item should be <strong>preselected automatically</strong>.
                  </li>
                  <li>Use this only when there is a clear default response.</li>
                </ul>

                <h2>Row Align</h2>
                <ul>
                  <li>
                    Turn on when short, related items should appear <strong>on the same row</strong>.
                  </li>
                  <li>Keep it off when items are longer or need their own line for readability.</li>
                </ul>

                <h2>Example structure:</h2>
                <p>
                  <strong>Neurological Examination</strong> <em>(Title)</em>
                  <br />→ <strong>Motor Function</strong> <em>(Header)</em>
                  <br />→ <strong>Upper Extremity</strong> <em>(Subheader)</em>
                  <br />→ <strong>Normal | Impaired | Absent</strong> <em>(Options)</em>
                </p>

                <h2>Selection behavior:</h2>
                <p>Selection rules such as Single Select apply only to options. Headers and Subheaders are not counted as selectable options. A Subheader can therefore be selected or used even when its parent Header is configured as Single Select.</p>
                <p>For example:</p>
                <p>
                  <strong>Header — Symptoms</strong>
                </p>
                <ul>
                  <li>Option A (Selected)</li>
                  <li>Option B</li>
                  <li>
                    Subheader: <strong>Motor Symptoms</strong> ← can still be selected/used independently
                    <ul>
                      <li>Option C</li>
                      <li>Option D</li>
                    </ul>
                  </li>
                </ul>
                <p>
                  Selecting a Subheader <strong>does not count as one of the Single Select choices</strong>, because Subheaders are not treated as options.
                </p>
              </div>
            </CModalBody>

            <CModalFooter>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setShowInfoModal(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal>
        </DivLoader>
      </div>
    </div>
  )
}

export default PhysicalView
